import React from "react";
import { Link } from "@evergis/ui";

type LinkProps = {
  href: string;
  title: string;
  download?: string;
  target?: string;
};

export function createNotificationLink(message: string, linkProps: LinkProps) {
  const { title, ...otherProps } = linkProps;

  const description = React.createElement("p", {}, message);
  const link = React.createElement(Link, { ...otherProps }, title);

  return React.createElement("div", {}, [description, link]);
}
